module.exports = __webpack_public_path__ + "img/female.02451b74.png";